import { Stack, Typography, TypographyProps } from "@mui/material";
import { FC } from "react";

import { AlarmOnOutlined, CancelPresentationOutlined, DeleteOutline, SettingsOutlined } from "@mui/icons-material";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import CachedOutlinedIcon from "@mui/icons-material/CachedOutlined";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import DoneOutlinedIcon from "@mui/icons-material/DoneOutlined";
import ErrorOutlineOutlinedIcon from "@mui/icons-material/ErrorOutlineOutlined";
import HelpOutlineOutlinedIcon from "@mui/icons-material/HelpOutlineOutlined";
import HourglassEmptyOutlinedIcon from "@mui/icons-material/HourglassEmptyOutlined";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import ReportProblemOutlinedIcon from "@mui/icons-material/ReportProblemOutlined";
import TaskAltOutlinedIcon from "@mui/icons-material/TaskAltOutlined";
import { IngestStatus } from "../../../Pages/admin/Ingest/IngestIndex/IngestProcessing/ingest-processing";

export interface TableCellIngestStatusProps {
  data: any;
}

const TableCellIngestStatus: FC<TableCellIngestStatusProps> = (props) => {
  // TODO : is circular references a problem ? Check and then modify here and in IngestProcessing, WorkflowApiService too
  const value = props.data.value as IngestStatus;
  let color: TypographyProps["color"];
  let icon;
  switch (value) {
    case IngestStatus.Ready:
      color = "primary.text";
      icon = <AlarmOnOutlined fontSize="small" />;
      break;
    case IngestStatus.Created:
      color = "primary.text";
      icon = <AddOutlinedIcon fontSize="small" />;
      break;
    case IngestStatus.PendingQC:
      color = "warning.main";
      icon = <RemoveRedEyeOutlinedIcon fontSize="small" />;
      break;
    case IngestStatus.WaitingMezz:
      color = "warning.main";
      icon = <HourglassEmptyOutlinedIcon fontSize="small" />;
      break;
    case IngestStatus.QcInProgress:
      color = "info.main";
      icon = <RemoveRedEyeOutlinedIcon fontSize="small" />;
      break;
    case IngestStatus.Running:
      color = "primary.text";
      icon = <CachedOutlinedIcon fontSize="small" />;
      break;
    case IngestStatus.WorkflowError:
      color = "error.main";
      icon = <SettingsOutlined fontSize="small" />;
      break;
    case IngestStatus.Rejected:
      color = "error.main";
      icon = <CancelOutlinedIcon fontSize="small" />;
      break;
    case IngestStatus.Accepted:
      color = "success.main";
      icon = <DoneOutlinedIcon fontSize="small" />;
      break;
    case IngestStatus.NeedCheckOrEdit:
      color = "warning.main";
      icon = <RemoveRedEyeOutlinedIcon fontSize="small" />;
      break;
    case IngestStatus.Completed:
      color = "success.main";
      icon = <TaskAltOutlinedIcon fontSize="small" />;
      break;
    case IngestStatus.Aborted:
      color = "error.main";
      icon = <ErrorOutlineOutlinedIcon fontSize="small" />;
      break;
    case IngestStatus.Deleted:
      color = "error.main";
      icon = <DeleteOutline fontSize="small" />;
      break;
    case IngestStatus.MissingMetadata:
      color = "warning.main";
      icon = <ReportProblemOutlinedIcon fontSize="small" />;
      break;
    case IngestStatus.Cancelled:
      color = "error.main";
      icon = <CancelPresentationOutlined fontSize="small" />;
      break;
    case IngestStatus.Unknown:
    default:
      color = "error.main";
      icon = <HelpOutlineOutlinedIcon fontSize="small" />;
      break;
  }

  return (
    <Stack direction="row" alignItems="center" spacing={0.5} color={color}>
      {icon}
      <Typography
        sx={{
          textOverflow: "ellipsis",
          whiteSpace: "normal",
          overflow: "hidden",
          wordWrap: "break-word",
        }}
      >
        {value}
      </Typography>
    </Stack>
  );
};

export default TableCellIngestStatus;
